import { Button, Form, Input, Modal, Space, Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ASIDeviceService } from "../../ducks/asi-devices/asi-devices";

interface DataType {
  _id: string;
  deviceId: string;
  description: string;
  comment?: string;
  ip: string;
  port: number;
  hubExternalId: string;
}

const DevicesList = () => {
  const [asiList, setASIList] = useState<DataType[]>([]);
  const [loading, setLoading] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editing, setEditing] = useState<DataType | null>(null);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();
  const asiService = new ASIDeviceService();

  const getASIList = async () => {
    setLoading(true);
    try {
      const response = await asiService.getAll();
      setASIList(response || []);
    } catch (error) {
      console.log(error);
      setASIList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getASIList();
  }, []);

  const openEdit = (asi: DataType) => {
    setEditing(asi);
    form.setFieldsValue({
      description: asi.description,
      comment: asi.comment || "",
    });
    setEditOpen(true);
  };

  const saveEdit = async () => {
    if (!editing) return;
    setSaving(true);
    try {
      const values = await form.validateFields();
      await asiService.updateMeta(editing._id, values);
      message.success("Сохранено");
      setEditOpen(false);
      getASIList();
    } catch (e) {
      console.log(e);
      message.error("Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
      render: (v) => v || "—",
    },
    {
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      render: (_, cam) => String(cam.ip + ":" + cam.port),
    },
    {
      title: "Hub",
      dataIndex: "hubExternalId",
      key: "hubExternalId",
    },
    {
      title: "Действия",
      key: "action",
      render: (_, asi) => (
        <Space size="middle">
          <Link to={`/devices/${asi._id}`}>Настройка</Link>
          <Button type="link" onClick={() => openEdit(asi)}>
            Редактировать
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        size="small"
        columns={columns}
        dataSource={asiList}
        loading={loading}
        rowKey={(i) => i._id}
        locale={{ emptyText: "ASI устройства не найдены" }}
      />
      <Modal
        title="Редактирование ASI"
        open={editOpen}
        onOk={saveEdit}
        onCancel={() => setEditOpen(false)}
        confirmLoading={saving}
        okText="Сохранить"
        cancelText="Отмена"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="description"
            label="Название / описание"
            rules={[{ required: true, message: "Обязательное поле" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="comment" label="Комментарий">
            <Input.TextArea rows={3} placeholder="Кабинет / место установки" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DevicesList;
